import axios from "axios"
import { sha512 } from "crypto-hash"
import FormButton from "../../components/FormButton"
import Permissions from "./Permissions"
import { getId, getToken } from "../../user/User"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const UserDetailView = ({ id, setId,
    name, setName,
    email, setEmail,
    password, setPassword,
    userPermissions, setUserPermissions,
}) => {
    const navigate = useNavigate()

    const handleBack = async e => {
        e.preventDefault()
        navigate("/user")
    }

    const onSave = async e => {
        e.preventDefault()
        axios.put(process.env.REACT_APP_API_URL + "/api/users/" + id, JSON.stringify({
            "email": email,
            "name": name
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            savePermissions(id, "Saved")
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find user with email address " + email + ".")
                    return
                } else if(statusCode === 409) {
                    toast.error("There is an user with the same email address.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    const onDelete = async e => {
        e.preventDefault()
        axios.delete(process.env.REACT_APP_API_URL + "/api/users/" + id, { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success("Deleted user " + name + ".")
            navigate("/user")
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find user #" + id + ".")
                    return
                } else if(statusCode === 409) {
                    toast.error("The user #" + id + " is used in the client(s): " + error.response.data.clients.map(String).join(", "))
                    return
                }
            }
            toast.error("Internal error.")
        })
    }
    
    const onCreate = async e => {
        e.preventDefault()
        var passwordHash = await sha512(password)
        axios.post(process.env.REACT_APP_API_URL + "/api/users", JSON.stringify({
            "email": email,
            "name": name,
            "password": passwordHash
        }), {
        headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(res => {
            setId(res.data.id)
            savePermissions(res.data.id, "Created")
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 409) {
                    toast.error("There is an user with the same email address.")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    async function savePermissions(userId, action) {
        axios.put(process.env.REACT_APP_API_URL + "/api/permissions/" + userId, JSON.stringify({
            "user_id": userId,
            "permissions": userPermissions
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success(action + " user " + name + " (#" + userId + ").")
            navigate("/user/" + userId)
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find user " + userId + ".")
                    return
                }
            }
            toast.error("Internal error.")
        })
    }
    
    return (
        <>
            <button className="btn btn-primary back" onClick={handleBack}>Back to overview</button><br /><br />

            <form className="form-horizontal">
                <div className="card card-primary">
                    <div className="card-body">
                        <div className="row">
                            <FormButton label="Email address" id="email" required="required" value={email} setValue={setEmail} icon="fa-solid fa-envelope" />
                            <FormButton label="Name" id="name" required="required" value={name} setValue={setName} icon="fa-solid fa-input-text" />
                            { id === null ? (
                                <FormButton label="Password" id="password" required="required" value={password} setValue={setPassword} icon="fa-solid fa-lock" type="password" minLength={8} />
                            ) : null }
                        </div>
                    </div>

                    <div className="card-body">
                        <Permissions data={userPermissions} setData={setUserPermissions} />
                    </div>

                    <div className="card-footer">
                        {id === null ? (
                            <button className="btn btn-success" onClick={onCreate}>Create user</button>
                        ) : (
                            id == getId() ? (
                                <button className="btn btn-primary" onClick={onSave}>Save user</button>
                            ) : (
                                <>
                                    <button className="btn btn-primary" onClick={onSave}>Save user</button>
                                    <button className="btn btn-danger" onClick={onDelete}>Delete user</button>
                                </>
                            )
                        )}
                    </div>
                </div>
            </form>
        </>
    )
}
   
export default UserDetailView